// extracted by mini-css-extract-plugin
export default {"rowBlock":"Row_rowBlock__tElkC","reverse":"Row_reverse__3E6Q1","rowBlockText":"Row_rowBlockText__uKLPf","title":"Row_title__4E4jU","text":"Row_text__vn+zz"};